"use client";

import { useEffect } from "react";
import Link from "next/link";
import Image from "next/image";
import { usePathname } from "next/navigation";
import posthog from "posthog-js";
import { Compass } from "lucide-react";

export default function NotFound() {
  const pathname = usePathname();

  useEffect(() => {
    posthog.capture("page_not_found_viewed", { path: pathname });
  }, [pathname]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-white px-6">
      <Link href="/" className="mb-12">
        <Image
          src="/funnlr_logo.png"
          alt="Funnlr"
          width={120}
          height={32}
          className="h-8 w-auto"
          priority
        />
      </Link>

      <div className="mx-auto max-w-md text-center">
        <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-full bg-amber-50">
          <Compass className="h-8 w-8 text-amber-500" />
        </div>

        <h1 className="font-heading text-2xl font-bold text-slate-900">
          Page not found
        </h1>
        <p className="mt-3 text-sm leading-relaxed text-slate-500">
          We couldn&apos;t find the page you were looking for. The link might be
          broken or the page may have moved.
        </p>

        <Link
          href="/"
          className="mt-8 inline-block rounded-full bg-brand-500 px-8 py-3 text-sm font-semibold text-white transition-colors hover:bg-brand-600"
        >
          Back to home
        </Link>
      </div>
    </div>
  );
}
